export default "__VITE_ASSET__282e227e__"